import React from 'react';
import './ContactUsAgents.css';
import { Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import AgentCard from './AgentCard';

const ContactUsAgents = () => {
  const pdpInitData = useSelector((state) => state.pdp.pdpInitData);
  const agentList = pdpInitData?.propertyDocumentsInformation?.agentDocumentDetailList?.length > 0 ? pdpInitData?.propertyDocumentsInformation?.agentDocumentDetailList : [];

  return (
      <div className="left_side_widget mb30 tour-pdp-details p0">
        <Row className="propertyInfoBoxHeading p0">
          <h3 className='propertyInfoBoxHeadingText' tabIndex="0" >Have Questions? Contact Us!</h3>
      </Row>
      <div className="agents-list">
        {agentList.map((agent) => (
          <AgentCard key={agent.id} agent={agent} />
        ))}
      </div>
    </div>
  );
};

export default ContactUsAgents;